import React, { useState, useEffect } from 'react';
import useAuth from "../../Auth/useAuth";
import { FaBell } from 'react-icons/fa';
import axios from 'axios';
import './Notifications.css';
import config from '../../config';

const getNotificationDataUrl = `${config.BASE_URL}/notify-trucks`;
const getTripNotificationDriverUrl = `${config.BASE_URL}/notify-driver`;
const updateTransitStatusUrl = `${config.BASE_URL}/update-transit-status`;

const Notifications = () => {

    const { username, userProfile, setAuth } = useAuth();

    const [notifyData, setNotifyData] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [newNotification, setNewNotification] = useState(false);

    const [notifyDriver, setNotifyDriver] = useState([]);

    const keyDisplayMap = {
        registration: "Registration",
        insurance: "Insurance",
        fitness: "Fitness",
        mv_tax: "MV Tax",
        puc: "PUC",
        ka_tax: "KA Tax",
        basic_and_KA_permit: "Basic & KA Permit",
    }

    const fetchNotifications = async () => {

        console.log('Fetching notifications...', username, userProfile);

        if (userProfile === 'driverAssociate') {

            console.log('Fetching <<DRIVER>> notifications...');

            try {
                const response = await axios.post(getTripNotificationDriverUrl,
                    { username, userProfile },
                    {
                        withCredentials: true,
                        headers: {
                            "Content-Type": "application/json",
                        }
                    }
                );

                console.log('Notifications fetched:', response.data);
                if (response.status === 200) {
                    setNotifyDriver(response.data);
                    console.log('Notifications fetched:', response.data);
                } else {
                    console.error('Error fetching notifications:', response.data);
                }
            } catch (error) {
                console.error('Error fetching notifications:', error);
            }
        } else {
            console.log('Fetching <<TRUCKS>>notifications...');
            try {
                const response = await axios.get(getNotificationDataUrl,
                    {
                        withCredentials: true,
                        headers: {
                            "Content-Type": "application/json",
                        }
                    }
                );
                console.log('Notifications fetched:', response.data);
                if (response.status === 200) {
                    setNotifyData(response.data);
                    console.log('Notifications fetched:', response.data);
                } else {
                    console.error('Error fetching notifications:', response.data);
                }
            } catch (error) {
                console.error('Error fetching notifications:', error);
            }
        }
    };

    // Function to schedule the fetching at 12:05 AM
    const scheduleFetchNotifications = () => {
        const now = new Date();
        let targetTime = new Date(now);
        targetTime.setHours(0, 5, 0, 0); // Set to 12:05 AM today or tomorrow

        if (targetTime <= now) {
            targetTime.setDate(now.getDate() + 1);
        }

        const timeUntilTarget = targetTime - now;

        setTimeout(() => {
            fetchNotifications(); // Fetch notifications once at 12:05 AM
            // After that, set an interval to fetch notifications every 24 hours
            setInterval(fetchNotifications, 24 * 60 * 60 * 1000); // 24 hours
        }, timeUntilTarget);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showDropdown && !event.target.closest('.notification-dropdown') && !event.target.closest('.notification-button')) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showDropdown]);

    useEffect(() => {
        // Initial fetch on component mount
        fetchNotifications();

        // Schedule the daily fetch at 12:05 AM
        scheduleFetchNotifications();
    }, []);

    const toggleDropdown = () => {
        if (showDropdown) {
            setShowDropdown(false);
        }
        else {
            setShowDropdown(true);
        }
        if (!showDropdown) {
            fetchNotifications(); // Fetch notifications only when opening
            setNewNotification(false);
        }
    };


    const handleStartTrip = async (TripID, TruckNumber, DestinationFrom, DestinationTo) => {
        try {
            const response = await axios.post(updateTransitStatusUrl, {
                TripID,
                TransitStatus: "Start",
                TruckNumber
            },
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                }
            });

            if (response.status === 200) {
                window.open(
                    `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(DestinationFrom)
                    }&destination=${encodeURIComponent(DestinationTo)
                    }&travelmode=driving`,
                    '_blank'
                );
            }
        } catch (error) {
            console.error("Error updating transit status:", error);
        }
    };

    return (
        <div className="notifications">
            <button
                className={`notification-button ${newNotification ? 'new-notification' : ''}`} // Add class when new notification
                onClick={toggleDropdown}
            >
                <FaBell className="notification-icon" />
                {newNotification && <div className="new-notification-badge"></div>} {/* Badge for new notifications */}
            </button>
            {showDropdown && (
                <div className="notification-dropdown">
                    {notifyData.length > 0 ? (
                        notifyData.map((item, index) => {
                            const isExpired = new Date(item.end_date) < new Date();
                            return (
                                <div
                                    key={index}
                                    className={`notification-card ${isExpired ? "highlight-yellow" : ""}`}
                                >
                                    <p><b>Truck No:</b> {item.truck_no.split(' ').join('')}</p>
                                    <p>{keyDisplayMap[item.field_name] || item.field_name}</p>
                                    <p><b>Expires on:</b> {new Date(item.end_date).toLocaleDateString()}</p>
                                    {isExpired && <span className="warning-icon">❗</span>}
                                </div>
                            );
                        })
                    ) : notifyDriver.length > 0 ? (
                        notifyDriver
                            .filter(item => {
                                const today = new Date().toLocaleDateString('en-GB');
                                return item.localDate === today;
                            })
                            .map((item, index) => (
                                <div key={index} className="driver-notification-card">
                                    <div className="route-info">
                                        <span className="from">{item.DestinationFrom}</span>
                                        <span className="arrow">→</span>
                                        <span className="to">{item.DestinationTo}</span>
                                    </div>
                                    {item.TransactionStatus === 'Open' && (
                                        <button
                                            className="start-button"
                                            onClick={() => handleStartTrip(item.TripID, item.TruckNumber, item.DestinationFrom, item.DestinationTo)}
                                        >
                                            Start
                                        </button>
                                    )}
                                </div>
                            ))
                    ) : (
                        <p>No notifications</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default Notifications;